import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled.div<{ $lines?: number; $hidden?: boolean }>`
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;
  ${({ $lines }) => ($lines ? `-webkit-line-clamp: ${$lines};` : '')}
`

export const SeeMore = styled.button`
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  margin-top: 8px;
  color: #2a6df5;
  cursor: pointer;
  font: inherit;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
`
